import React, { memo } from "react";
import {
  Stack,
  Typography,
  FormControlLabel,
  Switch,
  Chip,
} from "investira.react.components";
import { displays } from "investira.react.lib";
import { PessoaImage, MutedCopy } from "../../../components/molecules";
import { useEmpresasContext } from "../../../contexts/EmpresasContext";
import utils from "../../../utils";

const EmpresaHeader = memo((props) => {
  const { preciseOption = true } = props;

  const { state, actions } = useEmpresasContext();
  const {
    logo_pessoa_id,
    ativo,
    logo_ok,
    mercado,
    pessoa,
    pessoa_fantasia,
    pessoa_tipo_id,
    cnpj,
  } = state.pessoa;

  const xPessoaTipoList = utils.helpers.getPessoaTipoById(pessoa_tipo_id);

  const handleChange = (event) => {
    actions.handleShowPreciseChange(event.target.checked);
  };

  return (
    <Stack
      direction="row"
      spacing={3}
      alignItems="center"
      justifyContent="space-between"
      sx={{ py: 1 }}
      component="header"
      role="banner"
      aria-label="Cabeçalho da empresa"
    >
      <Stack direction="row" spacing={3} alignItems={{ xs: "flex-start" }}>
        <Stack>
          <PessoaImage
            id={logo_pessoa_id}
            logoPessoaId={logo_pessoa_id}
            alt={pessoa_fantasia || pessoa}
            title={pessoa}
            hasLogo={logo_ok}
            mercado={mercado}
            size={50}
          />
        </Stack>
        <Stack spacing={2}>
          <Stack>
            <Typography
              variant="h5"
              component="h1"
              color="textPrimary"
              aria-label={`Nome da empresa: ${pessoa_fantasia || pessoa}`}
            >
              {pessoa_fantasia || pessoa}
            </Typography>
            <Typography variant="body2" component="h2" color="textSecondary">
              {pessoa}
            </Typography>
          </Stack>
          <Stack flexGrow={1} direction="row" gap={1} flexWrap="wrap">
            {xPessoaTipoList.map((xPessoaTipo) => {
              return (
                <Chip
                  key={xPessoaTipo.descricao}
                  label={xPessoaTipo.descricao}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              );
            })}
            {cnpj && (
              <MutedCopy value={cnpj}>
                <Chip
                  label={displays.cnpj(cnpj)}
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ px: 1.5 }}
                />
              </MutedCopy>
            )}
          </Stack>
        </Stack>
      </Stack>
      {preciseOption && (
        <Stack>
          <FormControlLabel
            sx={{ marginRight: 0 }}
            control={
              <Switch checked={state.showPrecise} onChange={handleChange} />
            }
            label={
              <Typography variant="body2" color="textPrimary">
                Valores simples
              </Typography>
            }
          />
        </Stack>
      )}
    </Stack>
  );
});

EmpresaHeader.displayName = "EmpresaHeader";

export default EmpresaHeader;
